var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-ticket-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("customerService.add_work_order"),
            visible: _vm.dialogUploadVisible,
            width: "630px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUploadVisible = $event
            },
            close: _vm.handleDialogClose,
            open: _vm.handleDialogOpen,
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "div",
                {
                  staticClass: "section-title mb-12 mt-12",
                  staticStyle: { "margin-top": "0" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("customerService.business_type")) + " "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "section-tip line-bottom-1px",
                  staticStyle: { "padding-bottom": "5px" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("tips.choose_transaction")) + " ")]
              ),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    "label-width": "230px",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "left",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "operation_type",
                        label: _vm.$t("customerService.business_type"),
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.form.operation_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "operation_type", $$v)
                            },
                            expression: "form.operation_type",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: {
                              label: _vm.$t("data.payin_transaction"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            key: "2",
                            attrs: {
                              label: _vm.$t("data.payout_transaction"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            key: "4",
                            attrs: {
                              label: _vm.$t("data.refund_transaction"),
                              value: 4,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.operation_type === 1
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "section-title mb-12 mt-12" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("data.payin_details")) + " "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.form.operation_type === 2
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "section-title mb-12 mt-12" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("data.payout_details")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "section-tip line-bottom-1px",
                            staticStyle: { "padding-bottom": "5px" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("tips.fill_out_ticket_detail")) +
                                " "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.form.operation_type === 4
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "section-title mb-12 mt-12" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("data.refund_details")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "section-tip line-bottom-1px",
                            staticStyle: { "padding-bottom": "5px" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("tips.fill_out_ticket_detail")) +
                                " "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.form.operation_type === 1 ||
                          _vm.form.operation_type === 2
                            ? _c(
                                "el-form-item",
                                {
                                  key: "merchant_order_id_d",
                                  attrs: { prop: "merchant_order_id" },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "label" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "merchantAccount.merchant_order_id"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("el-tooltip", [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "tips.payout_mch_order_id"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                position: "relative",
                                                top: "-1px",
                                              },
                                              attrs: {
                                                "icon-class": "help-question",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("el-input", {
                                    staticClass: "from-input",
                                    attrs: {
                                      placeholder: "Enter Merchant Order ID",
                                      type: "text",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.merchant_order_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "merchant_order_id",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.merchant_order_id",
                                    },
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.operation_type === 4
                    ? [
                        _c(
                          "el-form-item",
                          {
                            key: "original_transaction_id",
                            attrs: {
                              label:
                                _vm.$t(
                                  "customerService.original_transaction_id"
                                ) + ":",
                              prop: "original_transaction_id",
                              required: "",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "from-input",
                              attrs: {
                                placeholder: "Original transaction ID",
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.original_transaction_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "original_transaction_id",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.original_transaction_id",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key: "original_transaction_amount",
                            attrs: {
                              label:
                                _vm.$t(
                                  "customerService.original_transaction_amount"
                                ) + ":",
                              prop: "original_transaction_amount",
                              required: "",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "from-input",
                              attrs: {
                                placeholder: "Original transaction amount",
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.original_transaction_amount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "original_transaction_amount",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "form.original_transaction_amount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key: "refund_amount",
                            attrs: {
                              label:
                                _vm.$t(
                                  "customerService.request_refund_amount"
                                ) + ":",
                              prop: "refund_amount",
                              required: "",
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "from-input",
                              attrs: {
                                placeholder: "Enter amount",
                                size: "small",
                                type: "text",
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.refund_amount,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "refund_amount", $$v)
                                },
                                expression: "form.refund_amount",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _vm.form.operation_type === 1 ||
                          _vm.form.operation_type === 2
                            ? _c(
                                "el-form-item",
                                {
                                  key: "amount",
                                  attrs: {
                                    label: _vm.$t("components.amount") + ":",
                                    prop: "amount",
                                    required: "",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "from-input",
                                    attrs: {
                                      placeholder: "Enter amount",
                                      type: "text",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.amount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "amount", $$v)
                                      },
                                      expression: "form.amount",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: "phone_no",
                              attrs: {
                                prop: "phone_no",
                                label: _vm.$t(
                                  "customerService.customer_phone_number"
                                ),
                                required: "",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  placeholder: "Enter customer mobile no.",
                                  type: "text",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.phone_no,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "phone_no", $$v)
                                  },
                                  expression: "form.phone_no",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.operation_type === 1 || _vm.form.operation_type === 4
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  key: "transaction_date",
                                  attrs: {
                                    prop: "transaction_date",
                                    rules: [
                                      {
                                        required: true,
                                        message:
                                          "Transaction Date cannot be empty",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "label" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "components.transaction_date"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c("el-tooltip", [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tips.transaction_time"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                position: "relative",
                                                top: "-1px",
                                              },
                                              attrs: {
                                                "icon-class": "help-question",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("el-date-picker", {
                                    staticClass: "from-input",
                                    attrs: {
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "Enter transaction time",
                                    },
                                    model: {
                                      value: _vm.form.transaction_date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "transaction_date",
                                          $$v
                                        )
                                      },
                                      expression: "form.transaction_date",
                                    },
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.form.operation_type,
                              attrs: {
                                label:
                                  _vm.$t("customerService.description") + ":",
                                prop: "issue",
                                required: "",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-input",
                                attrs: {
                                  placeholder: "Enter your message here",
                                  type: "textarea",
                                  clearable: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.enterInput(
                                      _vm.form.issue,
                                      "Description"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.form.issue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "issue", $$v)
                                  },
                                  expression: "form.issue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-bottom": "24px" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "upload-label" },
                            [
                              _vm.form.operation_type === 1 ||
                              _vm.form.operation_type === 4
                                ? _c(
                                    "span",
                                    { staticClass: "upload-label-text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#71110e",
                                            "margin-right": "4px",
                                          },
                                        },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "customerService.payment_receipt"
                                            )
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " (" +
                                          _vm._s(_vm.$t("tips.image_only")) +
                                          ") "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.form.operation_type === 2
                                ? _c(
                                    "span",
                                    { staticClass: "upload-label-text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#71110e",
                                            "margin-right": "4px",
                                          },
                                        },
                                        [_vm._v("*")]
                                      ),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "customerService.transaction_history"
                                          )
                                        )
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " (" +
                                          _vm._s(_vm.$t("tips.image_only")) +
                                          ") "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("el-tooltip", [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("tips.payment_receipt"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                  ]
                                ),
                                _c(
                                  "span",
                                  [
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "help-question" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-upload",
                            {
                              class: {
                                hideUploadFlag: _vm.isHideUpdate,
                                "upload-image": true,
                              },
                              attrs: {
                                action: "#",
                                "list-type": "picture-card",
                                "auto-upload": false,
                                "file-list": _vm.form.fileList,
                                limit: 1,
                                "on-change": _vm.handleImageChange,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function (ref) {
                                    var file = ref.file
                                    return _c("div", {}, [
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: { src: file.url, alt: "" },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlePictureCardPreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(file)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ]),
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "default" }, slot: "default" },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary", plain: "" } },
                                    [_vm._v("Click here to upload image")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("div", { staticClass: "upload-label" }, [
                            _c("span", { staticClass: "upload-label-text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("customerService.attachments"))
                              ),
                            ]),
                          ]),
                          _c(
                            "el-upload",
                            {
                              class: {
                                hideUploadFlag: _vm.isHideAttachmentUpdate,
                                "upload-image": true,
                              },
                              attrs: {
                                action: "#",
                                "auto-upload": false,
                                "file-list": _vm.form.attachmentList,
                                limit: 3,
                                "on-change": _vm.handleAttachmentChange,
                                "on-exceed": _vm.handleExceed,
                                "on-remove": _vm.handleAttachmentRemove,
                                disabled: _vm.uploadAttachmentLoading,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upload-file-defaule",
                                  attrs: {
                                    slot: "default",
                                    loading: _vm.uploadAttachmentLoading,
                                  },
                                  slot: "default",
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary", plain: "" } },
                                    [_vm._v("Click here to attach file")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submitLoading },
                  on: {
                    click: function ($event) {
                      return _vm.onClickSubmitBtn("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }